import React from 'react';
import DropdownMenu from '../../common/Dropdown.jsx';
import { FaIcon } from '../../common/Icons.jsx';
import { usePresets } from '../hooks/usePresets.js';
import ButtonSkeleton from '../../../skeleton_loaders/common/ButtonSkeleton.jsx';

function PresetDropdown({presetId, setPresetId, projectId, btnStyle}) {
  const {presets, isLoading} = usePresets({ projectId });

  if (!(presets && presets.length > 1)) return null;

  if (isLoading) return <ButtonSkeleton />

  return (<>
  {(presets && presets.length > 1) &&
    <DropdownMenu
      btnType='default'
      btnStyle={{maxHeight: '100%'}}
      label={<>
        {presetId
          ? (presets || []).find(p => p.value === presetId)?.label
          : I18n.t('select_preset')
        } <FaIcon type='caret-down' />
      </>}
      containerClass={`column-selector d-inline-block`}
    >
      {(presets || []).map((p) => (
        <li key={p.value}>
          <label>
            <input
              type='radio'
              value={p.value || 'default'}
              checked={presetId === p.value}
              onChange={(e) => setPresetId(e.target.checked && p.value)}
            />{' '}
            {p.label}
          </label>
        </li>
      ))}
    </DropdownMenu>}
  </>)
}

export default PresetDropdown;